import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { unlockCardOnFraudCleared } from '@src/api'
import { DefaultApiUnlockCardOnFraudClearedRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'
import { CustomError } from '@src/types'

export const useUnlockCardOnFraudCleared = () => {
  const { axiosInstance } = useAxios()

  return useMutation<
    unknown,
    AxiosResponse<CustomError>,
    DefaultApiUnlockCardOnFraudClearedRequest
  >({
    mutationFn: (params: DefaultApiUnlockCardOnFraudClearedRequest) =>
      unlockCardOnFraudCleared(axiosInstance, params),
  })
}
